module.exports = __webpack_public_path__ + "static/media/CT_2019_30449_9904.02462e9a.png";